import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { usePage } from '@inertiajs/react'
import { Button } from 'client/components/Button/Button'
import { GradientBorder } from 'client/components/GradientBorder/GradientBorder'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import ProductImage from 'images/product.jpg'
import { useShoppingCartController } from 'client/controllers/cartController'

type TProps = {}

type TPageProps = {
  product: Data.Product
}

const ProductBlock: FC<TProps> = () => {
  const {
    props: { product },
  } = usePage<TPageProps>()

  const { addProduct } = useShoppingCartController()

  return (
    <ResponsiveBlock className="py-20">
      <div className="grid w-full grid-cols-2 gap-8">
        <div className="flex w-full justify-end">
          <div className="flex h-[calc(570px)] w-[calc(570px)] flex-none">
            <img src={product.image ?? ProductImage} className="w-full object-cover" />
          </div>
        </div>
        <div className="flex w-full flex-col gap-10">
          <div className="flex w-full justify-between">
            <div className="flex">
              <GradientBorder className="h-10 w-full px-10">
                <Text tagName="span" className="uppercase text-palette-white">
                  Services
                </Text>
              </GradientBorder>
            </div>
            {!!product.seller?.id && (
              <div className="flex items-center gap-4">
                <Text
                  tagName="span"
                  className="font-body---14px uppercase text-palette-grey--50"
                >{`Seller: ${product.seller.name}`}</Text>
                <div className="block h-11 w-11 rounded-xl bg-palette-black--10 overflow-hidden">
                  <img src={product.seller.avatar} className="w-full object-cover h-full" />
                </div>
              </div>
            )}
          </div>
          <div className="flex w-full flex-col gap-8">
            <Text tagName="h1" className="font-body---40px text-palette-white">
              {product.name}
            </Text>
            {product.short_description && (
              <Text tagName="p" className="font-body---24px text-palette-grey--50">
                {product.short_description}
              </Text>
            )}
            <Text tagName="span" className="font-body---40px text-palette-white">
              {`€${product.price}`}
            </Text>
            <Button onClick={() => addProduct(product)}>Add to cart</Button>
            <div className="font-body---24px flex w-full flex-col gap-4 text-palette-grey--50 whitespace-pre-wrap">
              <Text tagName="span">Description of the service</Text>
              {product.description && <Text tagName="p">{product.description}</Text>}
            </div>
          </div>
        </div>
      </div>
    </ResponsiveBlock>
  )
}

export { ProductBlock }
